import { XMarkIcon } from '@heroicons/react/24/solid';
import { ActionIcon, Flex, Text } from '@mantine/core';

import { translate } from '@/shared/i18n/translate';
import { LBBadge } from '@/shared/ui-kit/components';

import type { ArtistLanguageLevels } from '../../../../@types/types';

export const ForeignLanguageItem = ({
  name,
  level,
  onRemove
}: {
  name: string;
  level: ArtistLanguageLevels;
  onRemove?: () => void;
}) => (
  <Flex direction='column' gap={4}>
    <LBBadge
      variant='outline'
      rightSection={
        onRemove && (
          <ActionIcon variant='transparent' onClick={onRemove}>
            <XMarkIcon width={16} />
          </ActionIcon>
        )
      }
    >
      {name}
    </LBBadge>
    <Text fz={12}>{translate(`commons.languages.${level}`)}</Text>
  </Flex>
);
